import { render, staticRenderFns } from "./VincularClube.vue?vue&type=template&id=3506fc76"
import script from "./VincularClube.vue?vue&type=script&lang=ts"
export * from "./VincularClube.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports